import { FetchRequestParameters } from './types';

interface CacheEntry<TData> {
  data: TData;
  validUntil: number;
}

const DATA_VALID_FOR_HOURS = 24;

export function createSimpleHttpCache<TData = any, TParameters = any>() {
  const cache = new Map<string, CacheEntry<TData>>();

  type RequestParameters = FetchRequestParameters & TParameters;

  const getCacheKey = (fetchParams: FetchRequestParameters, params: TParameters) =>
    JSON.stringify(fetchParams) + JSON.stringify(params);

  function getCacheEntry(key: string) {
    const entry = cache.get(key);
    if (entry && entry.validUntil > Date.now()) {
      return entry.data;
    }
    return null;
  }

  function setCacheEntry(key: string, data: TData) {
    cache.set(key, {
      data,
      validUntil: Date.now() + DATA_VALID_FOR_HOURS * 3600 * 1000,
    });
  }

  return { setCacheEntry, getCacheEntry, getCacheKey };
}
